import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Chile Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2018-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("chileExportLatestArrivalDate"),
    getSearchResult: getApiUrl("chileExportSearch"),
    getAnalyticsData: getApiUrl("analytics/chileExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_chile_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_chile_exports"),
    getShipmentByID: getApiUrl("chileExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfChileExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/chileExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ch_export.country_small,
  countryCaps: globalCountryDetails.ch_export.country_caps,
  product_id: globalCountryDetails.ch_export.product_id,
  compare_product_id: globalCountryDetails.ch_export.compareProduct,
  country_CamelCase: globalCountryDetails.ch_export.product_id,
  countryCode: globalCountryDetails.ch_export.countryCode,
  countryType: globalCountryDetails.ch_export.countryType,
  manyCountryType: globalCountryDetails.ch_export.manyCountryType,
  countryTypeCode: globalCountryDetails.ch_export.countryTypeCode,
  redirectionID: globalCountryDetails.ch_export.redirectionID,
  analyticsCountryID: globalCountryDetails.ch_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Departure Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ch_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
    portOfUnlading: "standardUnladingPortRegion",
  },
  filterObj: {
    transportMode: "transportMode",
    shipperName: "shipperName",
    shipperCity: "shipperCity",
    standardLadingPortName: "standardLadingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    custom: "custom",
    saleCondition: "saleCondition",
    carrierName: "carrierName",
    carrierCountryRegion: "carrierCountryRegion",
    vocc: "vocc",
    packageType: "packageType",
    incoterm: "incoterm",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    shipmentValue: "shipmentValue",
    weight: "weight",
    hsCode: "hsCode",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    carrierCountryRegion: "carrierCountry",
    standardUnladingPortRegion: "standardUnladingPortName",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    transportMode: [],
    shipperName: [],
    shipperCity: [],
    standardLadingPortName: [],
    standardUnladingPortRegion: [],
    custom: [],
    saleCondition: [],
    carrierName: [],
    carrierCountryRegion: [],
    vocc: [],
    // nvoccCode: [],
    packageType: [],
    incoterm: [],
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    shipmentValue: [],
    weight: [],
    hsCode: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    weight: "weight",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    weight: [],
    perUnitValue: [],
    quantityRange: [],
  },
  selectAll: {
    transportMode: false,
    shipperName: false,
    shipperCity: false,
    standardLadingPortName: false,
    standardUnladingPortRegion: false,
    custom: false,
    saleCondition: false,
    carrierName: false,
    carrierCountryRegion: false,
    vocc: false,
    packageType: false,
    incoterm: false,
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    shipmentValue: false,
    weight: false,
    hsCode: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "17", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Shipper City", categoryName: categoryType.shipperDetails, eventKey: "3", key: "shipperCity", type: filterType.normalFilter, label: "Shipper City", viewAllPlaceHolder: "Search in Shipper City Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Port of Lading", categoryName: categoryType.ports, eventKey: "4", key: "standardLadingPortName", type: filterType.normalFilter, label: "Port of Lading", viewAllPlaceHolder: "Search in Port of Lading Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Port of Unlading", categoryName: categoryType.ports, eventKey: "5", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search in Port of Unlading Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Carrier Name", categoryName: categoryType.carrierDetails, eventKey: "6", key: "carrierName", type: filterType.normalFilter, label: "Carrier Name", viewAllPlaceHolder: "Search in Carrier Name Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Carrier Country", categoryName: categoryType.carrierDetails, eventKey: "7", key: "carrierCountryRegion", altKey: "carrierCountry", type: filterType.localizeFilter, label: "Carrier Country", viewAllPlaceHolder: "Search in Carrier Country Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by VOCC", categoryName: categoryType.carrierDetails, eventKey: "8", key: "vocc", type: filterType.normalFilter, label: "VOCC", viewAllPlaceHolder: "Search in VOCC Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Custom", categoryName: categoryType.ports, eventKey: "9", key: "custom", type: filterType.normalFilter, label: "Custom", viewAllPlaceHolder: "Search in Custom Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "10", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Incoterm", categoryName: categoryType.freightType, eventKey: "11", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "", isNoTransform: true },
    { heading: "Filter by Package Type", categoryName: categoryType.cargoDetails, eventKey: "12", key: "packageType", type: filterType.normalFilter, label: "Package Type", viewAllPlaceHolder: "Search in Package Type Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Sale Condition", categoryName: categoryType.freightType, eventKey: "13", key: "saleCondition", type: filterType.normalFilter, label: "Sale Condition", viewAllPlaceHolder: "Search in Sale Condition Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "14", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchInFilterKey: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchInFilterKey: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "14", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Shipment Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "15", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "19", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "bill_of_lading", label: "BOL/Transport Document Number" },
    { key: "export_id", label: "Export ID" },
    { key: "voyage_number", label: "Voyage Number" },
    { key: "alias_derived_hs_codes", label: "HS Code" },
    { key: "hs_code", label: "HS Code" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_product_description", label: "Product Description (Spanish)" },
    { key: "derived_product_description_english", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_port_of_lading", label: "Port of Lading" },
    { key: "derived_port_of_unlading_english", label: "Port of Unlading" },
  ],
  shipmentSorting: [
    { columnKey: "derived_date_of_departure", value: "date", isDefault: true },
    { columnKey: "fob_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "derived_date_of_departure",
    shipment_value: "fob_value",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination_english", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "shipper_city" },
    { key: "custom", filterKey: "custom", label: "Customs House", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "shipper_city", filterKey: "shipperCity", label: "Shipper Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "derived_port_of_lading", filterKey: "standardLadingPortName", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading_english", profileType: redirectingProfileEnum.portOfLading.key },
    { key: "derived_port_of_unlading_english", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_lading", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "derived_vocc_name", filterKey: "vocc", label: "VOCCs", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "carrier_name", profileType: redirectingProfileEnum.vocc.key },
    { key: "carrier_name", filterKey: "carrierName", label: "Carriers", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "trade_port", filterKey1: "standardLadingPortName", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "Port of Lading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: "trade_city_destination_country", filterKey1: "shipperCity", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Shipper City → Country of Import)", headerOne: "Shipper City", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_sale_condition_english", headerLabel: "Sales Conditions", filterKey: "saleCondition", label: "Sales Conditions", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_mode_of_transport_english", headerLabel: "Mode of Transportation", filterKey: "transportMode", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2 digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "derived_date_of_departure", name: "Departure Date", selector: "derived_date_of_departure", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 2, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_product_description", name: "Product", selector: "derived_product_description", tooltipValue: "derived_product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 20, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_measure_unit_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "incoterm", name: "Incoterm", selector: "incoterm", dataTip: "", type: "", grow: 0, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "derived_country_of_destination_english", name: "Country of Import", selector: "derived_country_of_destination_english", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "fob_value", name: "Shipment Value (USD)", selector: "fob_value", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 1, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", sortable: true, selector: "shipment_value", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Departure", value: "derived_date_of_departure", dateFormat: true, monthFormat: false },
        { label: "BOL/Transport Document Date", value: "bill_of_lading_date", dateFormat: true, monthFormat: false },
        { label: "BOL/Transport Document Number", value: "bill_of_lading", capitalize: true },
        { label: "Export ID", value: "export_id" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport", capitalize: true },
        { label: "Sale Condition", value: "derived_sale_condition_english", tooltip: true, tooltipField: "sale_condition", capitalize: true },
        { label: "Incoterm", value: "derived_incoterm_english", tooltip: true, tooltipField: "incoterm", capitalize: true },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Keywords", value: "product_name", capitalize: true },
        // { label: '', value:'master_bol_number', capitalize:true,},
        // { label: '', value:'house_bol_number', capitalize:true,},
        // { label: '', value: 'derived_is_containerised',},
        // { label: 'HS Code', value: 'derived_mode_of_transport_english', isConditionalField: true,
        //     conditionalComponentData:[{
        //         dependentField: 'hs_codes_derived_string',
        //         mappingField: 'hs_code_description_map',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: true,
        //         label: 'HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         isThunderIcon: false
        //     },
        //     {
        //         dependentField: 'derived_estimated_hs_code_is_present',
        //         mappingField: 'hs_codes_estimated_description_map',
        //         infoText: 'These HS Code(s) have been estimated based on the shipment data.',
        //         isHSCodeFormatter: true,
        //         label: 'Estimated HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         hideField: true,
        //     },
        //     {
        //         dependentField: '',
        //         mappingField: '',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: false,
        //         label: 'HS Code',
        //         isReadMore: false,
        //         readMoreLength: 0,
        //         isThunderIcon: false
        //     }
        // ]},
        // { label: 'Product Keywords', value:'derived_unique_product_keywords', isReadMore:true, readMoreLength:160, capitalize:true, infoText:'Product keywords derived from detailed product description on each shipment.', isProductKeywordFormater: true},
        // { label: 'Estimated Shipment Value', value:'derived_shipment_value', isThunderIcon:true, valuePrefix:"USD ", isCommaFormat:true, fixedValueUpto:2,  infoText:'Shipment Value', hideField: true, },
        // { label: 'TEU', value: 'derived_shipment_teu', isThunderIcon: true, infoText:"Twenty-feet Equivalent Unit", hideField: true,},
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "shipper_name", isCapitalise: true },
        { label: "Shipper RUT Number", value: "derived_rut_number" },
        { label: "Shipper City", value: "shipper_city", isCapitalise: true },
        { label: "Custom", value: "custom", isCapitalise: true },
        { label: "Port of Lading", value: "derived_port_of_lading", isCapitalise: true, type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "country_of_destination", isCapitalise: false, countryCodeField: "derived_country_of_import_code", countryFlag: true },
        { label: "Port of Unlading", value: "derived_port_of_unlading_english", tooltip: true, tooltipField: "port_of_unlading", isCapitalise: true, type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
      ],
    },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Carrier Name", value: "carrier_name", isCapitalise: true },
        { label: "Carrier Country", value: "derived_carrier_country_english", tooltip: true, tooltipField: "carrier_country", isCapitalise: true },
        { label: "Voyage Number", value: "voyage_number" },
        { label: "Vessel Name", value: "vessel_name", isCapitalise: true },
        { label: "VOCC", value: "derived_vocc_name", tooltip: true, tooltipField: "derived_vocc_code", tooltipPrefix: "VOCC Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_vocc_name_id_combined", profileType: redirectingProfileEnum.vocc.key },
        { label: "NVOCC", value: "derived_nvocc_name", tooltip: true, tooltipField: "derived_nvocc_code", tooltipPrefix: "NVOCC Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_nvocc_name_id_combined", profileType: redirectingProfileEnum.nvocc.key },
      ],
    },
    {
      id: 5,
      isTitleDynamic: true,
      dynamicTitle: "export_id",
      title: "Bundled Cargo Details for Export Id: ",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Load Type", value: "derived_load_type_english", tooltip: true, tooltipField: "load_type", isCapitalise: true },
        { label: "Package Type", value: "derived_package_type_english", tooltip: true, tooltipField: "package_type", isCapitalise: true },
        { label: "Package Quantity", value: "package_quantity" },
        { label: "Gross Weight (kg)", value: "derived_shipment_gross_weight_kg" },
        { label: "Gross Weight (tonne)", value: "derived_gross_weight_tonne" },
        { label: "Package Description", value: "package_description", isCapitalise: true },
      ],
    },
    {
      id: 6,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "hs_code" },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "derived_product_description", isReadMore: true, readMoreLength: 45 },
        { label: "CIF Value (USD)", value: "cif_value" },
        { label: "Insurance Value (USD)", value: "insurance_value" },
        { label: "Freight Value (USD)", value: "freight_value" },
        { label: "FOB Value (USD)", value: "fob_value" },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "CIF per Unit (USD)", value: "derived_cif_per_unit" },
        { label: "Quantity", value: "quantity", unitField: "derived_measure_unit_english", dynamicUnit: true, preValidate: true },
        { label: "Weight (kg)", value: "derived_weight_kg", isCommaFormat: true },
      ],
    },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment departure date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Chile Exports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination_english",
  twoColumnMapping: {
    // derived_consignee_master_name:"Unique Importers",
    trade_country_of_export_to_import: "Trade Routes (Country of Export -> Country of Import)",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination_english: "Countries of Import",
    custom: "Customs House",
    shipper_city: "Shipper Cities",
    derived_port_of_lading: "Ports of Lading",
    derived_port_of_unlading_english: "Ports of Unlading",
    derived_vocc_name: "VOCCs",
    carrier_name: "Carriers",
    trade_port: "Trade Routes (Port of Lading → Port of Unlading)",
    trade_city_destination_country: "Trade Routes (Shipper City → Country of Import)",
    trade_port_destination_country: "Trade Routes (Port of Lading → Country of Import)",
    derived_sale_condition_english: "Sales Conditions",
    derived_mode_of_transport_english: "Mode of Transportation",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const ChileExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default ChileExportSearch;
